<template>
  <select :aria-label="placeholder"
          class="form-select"
          @change="toggleItem($event)"
          ref="selectInput">
    <option :value="placeholder" selected>{{ placeholder }}</option>
    <template v-for="(label, value) in labels">
      <option :value="value">{{ label }}</option>
    </template>
  </select>
</template>

<script setup>

// Props
import {ref} from "vue";

const props = defineProps({
  modelValue: Array,
  placeholder: String,
  labels: Object
});

// Events
const emit = defineEmits(['update:modelValue'])

const selectInput = ref({});

// method to toggle clicked item
const toggleItem = event => {
  // get value of clicked item
  const value = event.target.value;

  // only handle real values
  if(value !== props.placeholder) {
    // clone or create v-model
    let newModelValue = props.modelValue || [];

    // toggle
    const valueIndex = newModelValue.indexOf(value);
    if (valueIndex < 0) {
      newModelValue.push(value);
    } else {
      newModelValue.splice(valueIndex, 1);
    }

    // emit v-model change
    emit('update:modelValue', newModelValue);

    // reset select field
    selectInput.value.selectedIndex = 0;
  }
}

</script>
